import { render, staticRenderFns } from "./ChatCard.vue?vue&type=template&id=8f1d881c&scoped=true&"
import script from "./ChatCard.vue?vue&type=script&lang=js&"
export * from "./ChatCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatCard.vue?vue&type=style&index=0&id=8f1d881c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1d881c",
  null
  
)

export default component.exports